import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueLodash from "vue-lodash";
import VTooltip from "v-tooltip";
import { /*Grid,*/ GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import AsyncComputed from "vue-async-computed";
import plugInTranslations from "./plugins/pluginTranslations.js";
import excel_Helper from "./shared/excelHelper.js";

import "@progress/kendo-ui";
import "@progress/kendo-theme-bootstrap/dist/all.css";

import "../scss/style.scss";
import "element-ui/lib/theme-chalk/index.css";

import Cookies from "js-cookie";

import VueReCaptcha from "vue-recaptcha";

//import JsonCSV from "vue-json-csv";
//Vue.component("downloadCsv", JsonCSV);

Vue.config.productionTip = false;
Vue.config.performance = true;

Vue.use(BootstrapVue);

Vue.use(VueLodash);
Vue.use(GridInstaller);

Vue.use(AsyncComputed);

Vue.use(plugInTranslations);

Vue.use(excel_Helper);

Vue.use(VueReCaptcha);

const defaultLanguage = "en-US";

import IdleVue from "idle-vue";

const eventsHub = new Vue();
const idleOptions = { eventEmitter: eventsHub, idleTime: 60000 * 30 };

Vue.use(IdleVue, idleOptions);

import { getLoadedLanguages, getNrMessages } from "./i18n";

function translationsLoaded() {
  var loadedLanguages = getLoadedLanguages();
  var nrMessages = getNrMessages();
  if (loadedLanguages.length > 0 && nrMessages > 0) {
    /* .includes("en-US") */
    return true;
  }
  return false;
}

async function ensureProfiloUtente() {
  if (!store.getters.profiloUtente) {
    await store.dispatch("getUserInfo");
    await store.dispatch("getUserInfoProfilo");
    await store.dispatch("getSimboloValuta");
    return !!store.getters.profiloUtente;
  }
  return !!store.getters.profiloUtente;
}

function langPresente(x) {
  if (store.getters.profiloUtente) {
    var lingue = "" + store.getters.profiloUtente.lingue;
    var trovato = lingue.indexOf("," + x + ",") >= 0 || x === "en"; // FORZA l'INGLESE; ALTRIMENTI NON FUNZIONA NULLA!!!
    return !!trovato;
  } else {
    return true;
  }
}

function getLanguagesFromProfile() {
  var fullList = [
    "it-IT",
    "en-US",
    "fr-FR",
    "de-DE",
    "es-ES",
    "tr-TR",
    "pl-PL",
    "ru-RU",
    "pt-PT",
    "el-GR",
    "zh-CN",
    "zh-TW",
    "ja-JP",
    "nl-NL",
    "uk-UA"
  ];

  var corrispondenza = {
    "it-IT": "it",
    "en-US": "en",
    "fr-FR": "fr",
    "de-DE": "de",
    "es-ES": "es",
    "tr-TR": "",
    "pl-PL": "",
    "ru-RU": "",
    "pt-PT": "",
    "el-GR": "",
    "zh-CN": "",
    "zh-TW": "",
    "ja-JP": "",
    "nl-NL": "nl",
    "uk-UA": "uk"
    //,en,it,fr,de,es,uk,
  };

  var list = fullList.filter(x => {
    var loroDicitura = corrispondenza[x];
    if (loroDicitura !== "") {
      return langPresente(loroDicitura);
    } else {
      return false;
    }
  });

  return list;
}

router.beforeEach((to, from, next) => {
  store.dispatch("setLanguages", [
    "it-IT",
    "en-US",
    "fr-FR",
    "de-DE",
    "es-ES",
    "tr-TR",
    "pl-PL",
    "ru-RU",
    "pt-PT",
    "el-GR",
    "zh-CN",
    "zh-TW",
    "ja-JP",
    "nl-NL",
    "uk-UA"
  ]);

  var userLang = null;
  if (store.getters.loggedUserInfo) {
    userLang = store.getters.loggedUserInfo.appLanguage;
  }

  let lang = to.params.lang || store.getters.currentLanguage || defaultLanguage;

  if (userLang) {
    lang = userLang;
  }

  var bForceIt = false;
  var currLang = "" + document.querySelector("html").getAttribute("lang");
  if (currLang == "en") {
    currLang = "";
  }

  var isUserLogged = false;
  const token = Cookies.get("loginToken");
  if (token) {
    isUserLogged = true;
  }

  var transLoaded = translationsLoaded();

  //alert(isUserLogged);
  /*alert(currLang);*/

  if (isUserLogged) {
    if (currLang == "") {
      bForceIt = true;
    } else if (currLang !== lang) {
      bForceIt = true;
    }
    if (!transLoaded) {
      bForceIt = true;
    }
  }

  console.log("userLang = " + userLang);
  console.log("isUserLogged = " + isUserLogged);
  console.log("currLang = " + currLang);
  console.log("transLoaded = " + transLoaded);
  console.log("bForceIt = " + bForceIt);

  if (isUserLogged) {
    if (ensureProfiloUtente()) {
      var lingue = getLanguagesFromProfile();
      store.dispatch("setLanguages", lingue);
    }
  }

  if (bForceIt) {
    store.dispatch("forceChangeLanguage", lang).then(() => {
      next();
    });
  } else {
    next();
  }
});

Vue.use(VTooltip);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  render: h => h(App)
});

if (!String.format) {
  String.format = function(format) {
    const args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, (match, number) =>
      typeof args[number] !== "undefined" ? args[number] : match
    );
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}
